import * as React from "react";

function SvgLocation(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 19a21.392 21.392 0 01-2.5-2.55C8.357 15.07 7 13.015 7 11.057c0-1 .293-1.978.842-2.81a5.012 5.012 0 012.244-1.862 4.95 4.95 0 012.89-.288c.97.196 1.862.678 2.561 1.385a5.025 5.025 0 011.086 1.64A5.07 5.07 0 0117 11.056c0 1.958-1.357 4.013-2.5 5.393A21.392 21.392 0 0112 19zm0-10.11c-.568 0-1.113.23-1.515.635a2.178 2.178 0 00-.628 1.532c0 .575.226 1.126.628 1.532.402.406.947.634 1.515.634s1.113-.228 1.515-.634c.402-.406.628-.957.628-1.532 0-.574-.226-1.125-.628-1.532A2.131 2.131 0 0012 8.891z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgLocation;
